import { render } from "./wage-individual-factors.vue?vue&type=template&id=9ca74c5c"
import script from "./wage-individual-factors.vue?vue&type=script&lang=js"
export * from "./wage-individual-factors.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/applications/wagesetting/wage-individual-factors.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "9ca74c5c"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('9ca74c5c', __exports__)) {
    api.reload('9ca74c5c', __exports__)
  }
  
  module.hot.accept("./wage-individual-factors.vue?vue&type=template&id=9ca74c5c", () => {
    api.rerender('9ca74c5c', render)
  })

}


export default __exports__